let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l42ar")).then(() => parcelRequire('4V1hx'));